import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6786be19"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-end" };
const _hoisted_2 = { class: "flex w-full justify-end gap-2" };
import { ref } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import { useImpersonation } from '@apparatix/composables';
import Modal from '@apparatix/Components/Modal.vue';
import FormSkeleton from '@apparatix/Components/FormSkeleton.vue';
import { AppStore } from '@apparatix/stores/AppStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserMasqueradeModal',
    props: {
        visible: { type: Boolean },
        onClose: { type: Function }
    },
    setup(__props) {
        const { users, isLoading, impersonateUser } = useImpersonation(AppStore.realUser);
        const filters = ref({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        const selectedUser = ref();
        const onSubmit = async () => {
            const result = await impersonateUser(selectedUser.value);
            console.log(result);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, {
                visible: _ctx.visible,
                icon: "user",
                title: "Select a user to log in as",
                "on-close": _ctx.onClose
            }, {
                body: _withCtx(() => [
                    (_unref(isLoading))
                        ? (_openBlock(), _createBlock(FormSkeleton, { key: 0 }))
                        : _createCommentVNode("", true),
                    (!_unref(isLoading) && _unref(users).length)
                        ? (_openBlock(), _createBlock(_unref(DataTable), {
                            key: 1,
                            filters: filters.value,
                            "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((filters).value = $event)),
                            selection: selectedUser.value,
                            "onUpdate:selection": _cache[2] || (_cache[2] = ($event) => ((selectedUser).value = $event)),
                            "selection-mode": "single",
                            "data-key": "user_id",
                            value: _unref(users),
                            "global-filter-fields": ['user_userid', 'user_name']
                        }, {
                            header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createVNode(_unref(InputText), {
                                        modelValue: filters.value['global'].value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.value['global'].value) = $event)),
                                        placeholder: "Search for a user",
                                        class: "reasonable-padding"
                                    }, null, 8, ["modelValue"])
                                ])
                            ]),
                            empty: _withCtx(() => [
                                _createTextVNode(" No users match your search ")
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_unref(Column), {
                                    field: "user_name",
                                    header: "Name"
                                }),
                                _createVNode(_unref(Column), {
                                    field: "user_userid",
                                    header: "Username"
                                }),
                                _createVNode(_unref(Column), {
                                    field: "user_type",
                                    header: "Type"
                                })
                            ]),
                            _: 1
                        }, 8, ["filters", "selection", "value"]))
                        : _createCommentVNode("", true)
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Button), {
                            label: "Cancel",
                            class: "reasonable-padding",
                            severity: "secondary",
                            onClick: _ctx.onClose
                        }, null, 8, ["onClick"]),
                        _createVNode(_unref(Button), {
                            label: "Switch user",
                            class: "reasonable-padding",
                            disabled: !selectedUser.value,
                            onClick: onSubmit
                        }, null, 8, ["disabled"])
                    ])
                ]),
                _: 1
            }, 8, ["visible", "on-close"]));
        };
    }
});
